export function shouldPlayForegroundMessageSound({
  isEcho,
  sessionKey,
  currentSessionKey,
  isCallMessage,
}) {
  return !isEcho
    && sessionKey !== currentSessionKey
    && !isCallMessage;
}
